const WaiverForm = require('@/lib/Waivers/WaiverForm');
const { toDate, toInt, toString } = require('@/functions/transform');

class Waiver {
    constructor() {
        this.ID = null;

        /**
         * @type {string}
         */
        this.name = '';

        /**
         * @type {Date|null}
         */
        this.createdAt = null;

        /**
         * @type {Date|null}
         */
        this.completedAt = null;

        /**
         * @type {number}
         */
        this.completedFormCount = 0;

        /**
         * @type {number}
         */
        this.requiredFormCount = 0;

        /**
         * @type {number}
         */
        this.staffDeclaredFormCount = 0;

        /**
         * @type {string}
         */
        this.notes = '';

        /**
         * @type {Date|null}
         */
        this.redeemedAt = null;

        /**
         * @type {string}
         */
        this.waiverToken = '';

        /**
         * This is not provided in a request to /waivers. You must get it separately
         * by calling /waiver_forms?waiver_id=123
         *
         * @type {WaiverForm[]}
         */
        this.waiverForms = [];
    }

    getHydrationMap() {
        return {
            completedAt: toDate,
            completedFormCount: toInt,
            createdAt: toDate,
            ID: toInt,
            name: {
                field: ['name', 'waiverDefinitionName'],
                transform: toString,
            },
            notes: toString,
            redeemedAt: toDate,
            requiredFormCount: toInt,
            staffDeclaredFormCount: toInt,
            waiverToken: toString,

            // This isn't supplied by the API but may be present during rehydration.
            waiverForms: {
                modelCollection: WaiverForm,
            },
        };
    }

    /**
     * @return {boolean}
     */
    isComplete() {
        return !!this.completedAt;
    }

    /**
     * @return {boolean}
     */
    isRedeemed() {
        return !!this.redeemedAt;
    }

    /**
     * @param {AppConfig} appConfig
     */
    getWaiverLink(appConfig) {
        return appConfig.waiversUrl + '/waiver/' + this.waiverToken;
    }

    /**
     * @param {WaiverForm} form
     *
     * @return {boolean}
     */
    removeForm(form) {
        const index = this.waiverForms.indexOf(form);
        if (index !== -1) {
            this.waiverForms.splice(index, 1);
            return true;
        }

        return false;
    }
}

module.exports = Waiver;
